/**
 * Handles the deactivation of the future breadcrumbs
 * when the form gets edited
 * @module embed/breadcrumbs
 */
const SELECTOR = '.js-breadcrumbs';
const SELECTOR_ACTIVE = '.js-breadcrumbs__active';

function setupBreadcrumb(scope, el) {
  // As fields get edited, update prevent navigation
  // to slides further down in the breadcrumbs as they
  // would be no longer matching the data that has been
  // entered
  scope.addEventListener('change', function() {
    // Remove every future links
    Array.from(el.querySelectorAll(`${SELECTOR_ACTIVE} ~ li a`)).forEach(
      link => (link.parentNode.textContent = link.textContent)
    );
    // TODO: Maybe warn the user that because of edits
    // they'll need to go through the whole process again?
  });
}

export default function setupBreadcrumbs(el) {
  Array.from(el.querySelectorAll(SELECTOR)).forEach(widget =>
    setupBreadcrumb(el, widget)
  );
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/breadcrumb.js